import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavigationBar from "./NavigationBar";
import Footer from "./Footer";
import ConnectSection from "./ConnectSection";
import './MainLayout.css';

const MainLayout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const isBecomeAPartnerPage = pathname.includes("/become-a-partner");
  const isContactUs = pathname.includes("/contact-us");
  const isNotFoundPage = pathname.includes("/not-found");

  const shouldShowConnectSection = () => {
    const excludedPaths = [
      "/pricing",
      "/request-demo",
      "/tools",
      "/adr-calculator",
      "/revpar-calculator",
      "/trevpar-calculator",
      "/trevpab-calculator",
      "/goppar-calculator",
      "/cpor-calculator",
      "/alos-calculator",
      "/occupancy-rate",
    ];

    return !excludedPaths.some((path) => pathname.startsWith(path));
  };

  return (
    <div className="main-layout">
      <header>
        <NavigationBar onToggleMobileMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
      </header>

      <main style={{ filter: isMobileMenuOpen ? "blur(8px)" : "none" }}>
        <Outlet />
      </main>

      <footer id="main-footer">
        {!isContactUs &&
          !isBecomeAPartnerPage &&
          shouldShowConnectSection() &&
          !isNotFoundPage && <ConnectSection />}
        <Footer />
      </footer>
    </div>
  );
};

export default MainLayout;
